import { BLUE, OUTLINE_GREY, GREY, OVERVIEW_PAGE_GREY } from '../Constants/cssColors'

export default {
  ////////// General Page Styles //////////
  appHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  appFooter: {
    position: "fixed",
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 100,
    padding: 6,
    backgroundColor: "#efefef",
    textAlign: "Center",
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  loginPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Source Sans Pro, sans-serif',
    color: `black`,
    alignItems: 'center',
    padding: '3rem 1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    width: '80vw',
    textAlign: 'initial',
    alignSelf: 'flex-start',
  },
  subtitle: {
    fontSize: '1rem',
    fontWeight: '200',
    textAlign: 'initial',
    width: '80vw',
    alignSelf: 'flex-start',
  },
  infoText: {
    fontSize: '1rem',
    fontWeight: 200,
    textAlign: 'left',
  },
  detailsContainer: {
    margin: '1rem 0',
    width: '80vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  textFieldFullWidth: {
    width: '80vw',
  },
  textFieldMediumWidth: {
    width: '80vw',
  },
  textFieldHalfWidth: {
    width: '80vw',
  },
  merchantInputFieldRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80vw',
  },
  ////////// Upload Image Buttons //////////
  buttonImageRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '80vw',
  },
  buttonContainer: {
    width: '60vw',
    height: '40vW',
    margin: '1vw 0',
    padding: '1vw',
    border: `3px solid ${OUTLINE_GREY}`,
    background: `${OVERVIEW_PAGE_GREY}`,
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buoyLogo: {
    width: '8rem',
  },
  buttonIcon: {
    width: 'inherit',
    height: 'inherit',
    objectFit: 'contain',
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageButtonTitle: {
    color: '#55575A',
    margin: '1rem 0',
  },
  imageUploadError: {
    color: 'red',
    fontSize: '0.9rem',
    alignSelf: 'center',
    width: '60vw',
  },
  imageButtonInfoText: {
    fontSize: '0.7rem',
    fontWeight: 200,
    width: '60vw',
    padding: '0.5rem 0',
    alignSelf: 'center',
  },
  uploadImageIcon: {
    width: '12vw',
    height: '12vw',
  },
  /////////// Social Media Links //////////
  fontAwesomeIcon: {
    height: '1.5rem',
    width: '1.5rem',
  },
  handlePrefix: {
    fontSize: '1.5rem',
    marginLeft: '1vw',
    marginRight: '-0.5vw',
  },
  ////////// Login, Signup, Password Recovery //////////
  loginSignupTitle: {
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '2rem',
    fontWeight: 'bold',
    padding: '1.5rem 0.5rem 0.5rem',
  },
  loginContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80vw',
    margin: '1vw',
    padding: '1vw',
  },
  loginButton: {
    width: '80vw',
    padding: '1rem',
    margin: '1vw 0',
  },
  forgotPassword: {
    alignSelf: 'flex-start',
    fontSize: '1rem',
    margin: '1rem 0',
    cursor: 'pointer',
    color: `${BLUE}`,
  },
  signUpOrLogIn: {
    alignSelf: 'flex-start',
    fontSize: '1rem',
    cursor: 'pointer',
    color: `${BLUE}`,
  },
  ////////// Google Places //////////
  googlePlacesList: {
    width: '80vw',
    backgroundColor: 'white',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300,
    border: '1px solid black',
  },
  googlePlaceIcon: {
    height: '5vw',
    width: '5vw',
    marginRight: '1rem',
  },
  googlePlaceTitleAndAddress: {
    display: 'flex',
    flexDirection: 'column',
    width: '24vw',
  },
  selectButton: {
    fontSize: '2vw',
  },
  ////////// App Bar //////////
  profileAppBar: {
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 200,
    backgroundColor: `white`,
  },
  profileToolBar: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '94vw',
  },
  mobileMenuIcon: {
    color: `${BLUE}`,
    width: '5vw',
    height: '5vw',
  },
  homePageTabs: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginTop: '1vw',
  },
  appBarBuoyLogo: {
    width: '8vw',
    position: 'absolute',
    left: '50%',
    marginTop: 2,
  },
  appBarMerchantLogo: {
    width: '8vw',
    height: '8vw',
    objectFit: 'contain',
  },
  homePageTabFonts: {
    fontSize: '2vw',
  },
  /////////// Edit User //////////
  editUserButtonRow: {
    margin: '1rem 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  backSaveButtonGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1rem',
  },
  /////////// Locations //////////
  locationCard: {
    width: '60vw',
    margin: '1vw 1vw 1vw 0',
  },
  locationsMap: {
    height: '100%',
    width: '80vw',
  },
  mapContainer: {
    height: '200px',
    margin: '0 0 4rem',
  },
  locationSearchField: {
    width: '80vw',
    paddingTop: '1vw',
  },
  locationCardTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    fontSize: '4.5vw',
    textAlign: 'left',
    height: '20vw',
    justifyContent: 'space-around',
  },
  locationCardAddress: {
    color: '#6A6767',
    fontSize: '3vw',
    textAlign: 'left',
  },
  locationCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '45vw',
    paddingTop: 0,
    paddingBottom: 0,
    justifyContent: 'space-around',
  },
  locationCardFooter: {
    width: '100%',
    margin: '0.7vw 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  addressLocationContainer: {
    width: '80vw',
    display: 'flex',
    flexWrap: 'wrap',
  },
  googleImageContainer: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  locationCardRow: {
    marginBottom: '0.8vw',
    fontSize: '3vw',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  locationCardButtonRow: {
    margin: '0.5rem 0',
    display: 'flex',
    flexFlow: 'column',
    fontSize: '2vw',
  },
  locationListHeader: {
    display: 'flex',
    margin: '3vw 0',
    alignSelf: 'flex-start',
  },
  terminalVerificationInfo: {
    color: `${GREY}`,
    margin: '1rem 0',
  },
  ////////// Awaiting Review //////////
  buoyLogoAwaitingPage: {
    width: '20vw',
    marginBottom: '1rem',
  },
  ////////// Legal Notices //////////
  agreementsContainer: {
    width: '80vw',
  },
  agreementBody: {
    fontSize: '0.9rem',
    fontWeight: 200,
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    width: '70vw',
  },
  legalNoticeTitle: {
    fontSize: '1.5rem',
    textAlign: 'left',
  },
  acceptAgreementText: {
    fontSize: '0.8rem',
  },
  agreementsAcceptSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  ////////// Overview Page //////////
  homePageContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Source Sans Pro, sans-serif',
    alignItems: 'center',
    padding: '2rem 0',
    backgroundColor: `${OVERVIEW_PAGE_GREY}`,
    minHeight: '100vh',
    width: '100%',
  },
  overviewPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Source Sans Pro, sans-serif',
    color: `black`,
    alignItems: 'center',
    padding: '2vw 0',
  },
  swipeableViewContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  overviewPageSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '80vw',
    marginTop: '3vw',
  },
  reportingSection: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  reportingCard: {
    width: '39vw',
    height: '25vw',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0 2vw',
    justifyContent: 'flex-start',
  },
  reportingCardTitle: {
    color: `${GREY}`,
    fontSize: '3vw',
  },
  reportingCardContent: {
    fontSize: '1.2rem',
    textAlign: 'left',
    padding: '4.5vw',
  },
  offerCard: {
    width: '39vw',
    height: '25vw',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0 2vw 0',
    justifyContent: 'center',
  },
  offerCardTitle: {
    margin: '1vw 0',
    fontWeight: 600,
    fontSize: '3vw',
  },
  offerCardContent: {
    fontSize: '3vw',
    padding: '5vw',
  },
  reportingCardValue: {
    fontSize: '5vw',
    fontWeight: 400,
    margin: '0.5vw 0',
  },
  reportingCardFooter: {
    color: '#B6B6B6',
    display: 'flex',
    flexWrap: 'wrap',
    whiteSpace: 'pre',
    fontSize: '3vw',
  },
  remainingActionsContainer: {
    textAlign: 'left',
    width: '80vw',
  },
  remainingActionsBox: {
    padding: '1rem',
  },
  remainingActionsTitle: {
    fontSize: '1.5rem',
  },
  remainingActionsSubtitle: {
    fontSize: '1.2rem',
    color: `${GREY}`,
    margin: '1rem 0',
  },
  remainingActionsEntry: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '1rem 0',
  },
  remainingActionsMobileTooltip: {
    fontSize: '0.7rem',
    fontWeight: 200,
  },
  remainingActionsCheckIcon: {
    color: `${OUTLINE_GREY}`,
    width: '2rem',
    height: '2rem',
    marginRight: '2rem',
  },
  remainingAction: {
    fontSize: '1.2rem',
    color: `${BLUE}`,
    textAlign: 'left',
  },
  remainingActionInfoIcon: {
    height: '1.5rem',
    padding: '0 1vw',
  },
  ////////// Offers Page //////////
  offerContainer: {
    width: '80vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2vw 0',
    margin: '2vw 2vw 2vw 0',
    height: '140vw',
    justifyContent: 'space-around',
  },
  offersSubtitle: {
    fontSize: '1rem',
    fontWeight: '200',
    textAlign: 'initial',
    width: '80vw',
    alignSelf: 'flex-start',
    marginBottom: '0.5rem',
  },
  offerCardLogo: {
    height: '8vw',
  },
  offerPanelContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  offerButtonContainer: {
    display: 'flex',
    margin: '0.5vw 0',
  },
  editOffersPanelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    marginTop: '2vw',
  },
  acqOfferButton: {
    fontSize: '1rem',
    padding: '2vw 10vw',
  },
  buttonTextSubtext: {
    fontSize: '0.7rem',
  },
  noSubtextButton: {
    padding: '0.4rem 0',
  },
  regOfferButton: {
    fontSize: '1rem',
    padding: '2vw 12vw',
  },
  offerPanelTitle: {
    fontSize: '1.5rem',
    fontWeight: 400,
    margin: '1rem 0 0.5rem',
  },
  offerPanelSubtitle: {
    fontSize: '0.8rem',
    color: '#6B6B6B',
    padding: '0 3vw 1vw',
    height: '10vw',
  },
  offerLogo: {
    height: '10vw',
  },
  logoutLink: {
    position: 'absolute',
    right: 0,
    top: 0,
    margin: '30px',
    fontSize: '0.9rem',
  },
  acqOfferInfoIcon: {
    height: '1.5rem',
    padding: '0 0.5vw',
  },
  ////////// Edit Side Panel //////////
  sidepanelTitle: {
    fontFamily: 'Source Sans Pro, sans-serif',
    margin: '2vw',
    textAlign: 'left',
    fontSize: '1.2rem',
  },
  sidepanel: {
    fontFamily: 'Source Sans Pro, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    width: '25vw',
    margin: '0 2vw',
  },
  bannerImage: {
    width: '25vw',
    height: '12vw',
    backgroundColor: '#E0DDDD',
    marginBottom: '5vw',
    objectFit: 'cover',
  },
  logoImage: {
    width: '8vw',
    height: '8vw',
    backgroundColor: 'white',
    position: 'absolute',
    marginTop: '8vw',
    marginLeft: '2.5vw',
    boxShadow: '0 3px 5px #888888',
    objectFit: 'contain',
  },
  merchantName: {
    fontSize: '2rem',
    textAlign: 'left',
    fontWeight: 600,
    margin: '0 2.5vw',
    wordWrap: 'break-word',
  },
  aboutMerchantSection: {
    fontSize: '1.3rem',
    fontWeight: 200,
    color: '#7C7C7C',
    margin: '2vw 2.5vw',
    textAlign: 'left',
    minHeight: '5vw',
  },
  contactInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 2.5vw 2vw',
  },
  contactSection: {
    width: '20vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '1vw 0',
  },
  contactInfo: {
    marginLeft: '1vw',
    fontWeight: 200,
  },
  ////////// Graphs Section //////////
  graphSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '0.5vw 0',
  },
  graphContainer: {
    width: '80vw',
    height: '60vw',
  },
  ////////// Verify Terminals - onboarding //////////
  // Note: this is not yet developed. We'll need a mobile design as well
  verifyTerminalPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    width: '40vw',
  },
  verifyTerminalHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    background: '#F8F8F8',
    padding: '2rem',
  },
  locationName: {
    fontSize: 'larger',
    fontWeight: 700,
    margin: '0rem 1rem 1rem 0rem',
  },
  verificationCardSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '1rem',
  },
  verificationCardIframe: {
    height: '11rem',
    marginRight: '1rem',
    borderWidth: 0,
  },
  yourVerificationCard: {
    fontWeight: 600,
    paddingBottom: '1rem',
  },
  yourVerificationCardSubtitle: {
    fontSize: '0.8rem',
    paddingBottom: '1rem',
  },
  verifyTerminalInstructionsList: {
    paddingBottom: '2rem',
    fontSize: '0.9rem',
    lineHeight: '1.5em',
    height: 'auto',
    marginRight: '1rem',
  },
  generateNewCardLink: {
   color: `${BLUE}`,
   cursor: 'pointer',
   fontSize: '0.9rem',
  },
  ////////// Verify Terminals - edit page //////////
  instructionsSet: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    lineHeight: '1.6',
  },
  instructionsList: {
    listStylePosition: 'inside',
    paddingLeft: '1rem',
  },
  activeTerminalsCount: {
    display: 'flex',
    marginBottom: '1rem',
  },
  existingVirtualCards: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: '1rem',
  },
  virtualCardModal: {
    width: '83vw',
    height: '28vh',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  virtualCardIFrame: {
    width: '83vw',
    height: '35vh',
  },
}
